export const SET_LANG = 'setLang'
export const GET_DEV_INFOS = 'getDevInfos'
export const SET_CHP_DEV_SELECT = 'setChpDevSelect'
export const SET_EWH_DEV_SELECT = 'setEwhDevSelect'
export const GET_GROUP_INFOS = 'getGroupInfos'
export const SET_CUR_MSG = 'setCurMsg'
export const SET_CUR_LOGIN_USER = 'setCurLoginUser'
export const SET_PRE_ROUTE_NAME = 'setPreRouteName'
export const SET_SEL_DEV_GRP_NAME = 'setSelDevGrpName'
export const SET_THEME_COLOR = 'setThemeColor'
export const SET_SYSTEM_INFO = 'setSystemInfo'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js